"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENESYS_DEV_ICONS_CODEPOINTS = exports.GenesysDevIcons = void 0;
var GenesysDevIcons;
(function (GenesysDevIcons) {
    GenesysDevIcons["AppAnnouncementEdit"] = "app-announcement-edit";
    GenesysDevIcons["AppAnnouncement"] = "app-announcement";
    GenesysDevIcons["AppBug"] = "app-bug";
    GenesysDevIcons["AppBusiness"] = "app-business";
    GenesysDevIcons["AppCalendar"] = "app-calendar";
    GenesysDevIcons["AppChangeSet"] = "app-change-set";
    GenesysDevIcons["AppCheckSolid"] = "app-check-solid";
    GenesysDevIcons["AppCheckStroke"] = "app-check-stroke";
    GenesysDevIcons["AppCheck"] = "app-check";
    GenesysDevIcons["AppChevronDown"] = "app-chevron-down";
    GenesysDevIcons["AppChevronLeft"] = "app-chevron-left";
    GenesysDevIcons["AppChevronRight"] = "app-chevron-right";
    GenesysDevIcons["AppChevronUp"] = "app-chevron-up";
    GenesysDevIcons["AppCopy"] = "app-copy";
    GenesysDevIcons["AppCriticalSolid"] = "app-critical-solid";
    GenesysDevIcons["AppDataSource"] = "app-data-source";
    GenesysDevIcons["AppDiff"] = "app-diff";
    GenesysDevIcons["AppDocumentEdit"] = "app-document-edit";
    GenesysDevIcons["AppDocumentEye"] = "app-document-eye";
    GenesysDevIcons["AppDocumentMarkdown"] = "app-document-markdown";
    GenesysDevIcons["AppEllipsisVertical"] = "app-ellipsis-vertical";
    GenesysDevIcons["AppEllipsis"] = "app-ellipsis";
    GenesysDevIcons["AppEmail"] = "app-email";
    GenesysDevIcons["AppExpand"] = "app-expand";
    GenesysDevIcons["AppExternalLink"] = "app-external-link";
    GenesysDevIcons["AppEye"] = "app-eye";
    GenesysDevIcons["AppFilter"] = "app-filter";
    GenesysDevIcons["AppGripNe"] = "app-grip-ne";
    GenesysDevIcons["AppGripNw"] = "app-grip-nw";
    GenesysDevIcons["AppGripSe"] = "app-grip-se";
    GenesysDevIcons["AppGripSw"] = "app-grip-sw";
    GenesysDevIcons["AppHandshake"] = "app-handshake";
    GenesysDevIcons["AppInfoSolid"] = "app-info-solid";
    GenesysDevIcons["AppKey"] = "app-key";
    GenesysDevIcons["AppLink"] = "app-link";
    GenesysDevIcons["AppListView"] = "app-list-view";
    GenesysDevIcons["AppLocation"] = "app-location";
    GenesysDevIcons["AppMinusSolid"] = "app-minus-solid";
    GenesysDevIcons["AppMinusStroke"] = "app-minus-stroke";
    GenesysDevIcons["AppMinus"] = "app-minus";
    GenesysDevIcons["AppMoon"] = "app-moon";
    GenesysDevIcons["AppNotificationsSolid"] = "app-notifications-solid";
    GenesysDevIcons["AppNotifications"] = "app-notifications";
    GenesysDevIcons["AppPinSolid"] = "app-pin-solid";
    GenesysDevIcons["AppPinStroke"] = "app-pin-stroke";
    GenesysDevIcons["AppPlusSolid"] = "app-plus-solid";
    GenesysDevIcons["AppPlusStroke"] = "app-plus-stroke";
    GenesysDevIcons["AppPlus"] = "app-plus";
    GenesysDevIcons["AppQuestionSolid"] = "app-question-solid";
    GenesysDevIcons["AppRefresh"] = "app-refresh";
    GenesysDevIcons["AppSearch"] = "app-search";
    GenesysDevIcons["AppShieldCheck"] = "app-shield-check";
    GenesysDevIcons["AppSortDown"] = "app-sort-down";
    GenesysDevIcons["AppSortUp"] = "app-sort-up";
    GenesysDevIcons["AppSort"] = "app-sort";
    GenesysDevIcons["AppStarSolidThin"] = "app-star-solid-thin";
    GenesysDevIcons["AppStarSolid"] = "app-star-solid";
    GenesysDevIcons["AppStarStrokeThick"] = "app-star-stroke-thick";
    GenesysDevIcons["AppStarStroke"] = "app-star-stroke";
    GenesysDevIcons["AppSuccessSolid"] = "app-success-solid";
    GenesysDevIcons["AppSun"] = "app-sun";
    GenesysDevIcons["AppThumbsDown"] = "app-thumbs-down";
    GenesysDevIcons["AppThumbsUp"] = "app-thumbs-up";
    GenesysDevIcons["AppTimesSolid"] = "app-times-solid";
    GenesysDevIcons["AppTimesStroke"] = "app-times-stroke";
    GenesysDevIcons["AppTimes"] = "app-times";
    GenesysDevIcons["AppTreeView"] = "app-tree-view";
    GenesysDevIcons["AppUserSolid"] = "app-user-solid";
    GenesysDevIcons["AppUser"] = "app-user";
    GenesysDevIcons["AppWarnSolid"] = "app-warn-solid";
    GenesysDevIcons["AppYeti"] = "app-yeti";
    GenesysDevIcons["AppZoomZoomDown"] = "app-zoom-zoom-down";
    GenesysDevIcons["AppZoomZoomLeft"] = "app-zoom-zoom-left";
    GenesysDevIcons["AppZoomZoomRight"] = "app-zoom-zoom-right";
    GenesysDevIcons["AppZoomZoomUp"] = "app-zoom-zoom-up";
    GenesysDevIcons["BrandGithubLarge"] = "brand-github-large";
    GenesysDevIcons["BrandGithub"] = "brand-github";
    GenesysDevIcons["BrandMarkdown"] = "brand-markdown";
    GenesysDevIcons["BrandNpm"] = "brand-npm";
    GenesysDevIcons["DestAccounts"] = "dest-accounts";
    GenesysDevIcons["DestApiExplorer"] = "dest-api-explorer";
    GenesysDevIcons["DestApi"] = "dest-api";
    GenesysDevIcons["DestAppFoundry"] = "dest-app-foundry";
    GenesysDevIcons["DestBlog"] = "dest-blog";
    GenesysDevIcons["DestBlueprint"] = "dest-blueprint";
    GenesysDevIcons["DestCog"] = "dest-cog";
    GenesysDevIcons["DestForum"] = "dest-forum";
    GenesysDevIcons["DestGetStarted"] = "dest-get-started";
    GenesysDevIcons["DestGuide"] = "dest-guide";
    GenesysDevIcons["DestNotifications"] = "dest-notifications";
    GenesysDevIcons["DestPages"] = "dest-pages";
    GenesysDevIcons["DestResourceCenter"] = "dest-resource-center";
    GenesysDevIcons["DestSdkDoc"] = "dest-sdk-doc";
    GenesysDevIcons["DestTechRef"] = "dest-tech-ref";
    GenesysDevIcons["DestTool"] = "dest-tool";
    GenesysDevIcons["DestTutorial"] = "dest-tutorial";
    GenesysDevIcons["DestVideo"] = "dest-video";
    GenesysDevIcons["DestWrench"] = "dest-wrench";
    GenesysDevIcons["EditorAccordionStroke"] = "editor-accordion-stroke";
    GenesysDevIcons["EditorAccordion"] = "editor-accordion";
    GenesysDevIcons["EditorAlignCenterStroke"] = "editor-align-center-stroke";
    GenesysDevIcons["EditorAlignCenter"] = "editor-align-center";
    GenesysDevIcons["EditorAlignLeftStroke"] = "editor-align-left-stroke";
    GenesysDevIcons["EditorAlignLeft"] = "editor-align-left";
    GenesysDevIcons["EditorAlignRightStroke"] = "editor-align-right-stroke";
    GenesysDevIcons["EditorAlignRight"] = "editor-align-right";
    GenesysDevIcons["EditorApi"] = "editor-api";
    GenesysDevIcons["EditorBlockquoteStroke"] = "editor-blockquote-stroke";
    GenesysDevIcons["EditorBlockquote"] = "editor-blockquote";
    GenesysDevIcons["EditorBoldStroke"] = "editor-bold-stroke";
    GenesysDevIcons["EditorBold"] = "editor-bold";
    GenesysDevIcons["EditorCalloutStroke"] = "editor-callout-stroke";
    GenesysDevIcons["EditorCallout"] = "editor-callout";
    GenesysDevIcons["EditorCodeStroke"] = "editor-code-stroke";
    GenesysDevIcons["EditorCode"] = "editor-code";
    GenesysDevIcons["EditorEraserStroke"] = "editor-eraser-stroke";
    GenesysDevIcons["EditorEraser"] = "editor-eraser";
    GenesysDevIcons["EditorHeadingStroke"] = "editor-heading-stroke";
    GenesysDevIcons["EditorHeading"] = "editor-heading";
    GenesysDevIcons["EditorHorizontalRuleStroke"] = "editor-horizontal-rule-stroke";
    GenesysDevIcons["EditorHorizontalRule"] = "editor-horizontal-rule";
    GenesysDevIcons["EditorImageStroke"] = "editor-image-stroke";
    GenesysDevIcons["EditorImage"] = "editor-image";
    GenesysDevIcons["EditorItalicStroke"] = "editor-italic-stroke";
    GenesysDevIcons["EditorItalic"] = "editor-italic";
    GenesysDevIcons["EditorLinkStroke"] = "editor-link-stroke";
    GenesysDevIcons["EditorLink"] = "editor-link";
    GenesysDevIcons["EditorListStroke"] = "editor-list-stroke";
    GenesysDevIcons["EditorList"] = "editor-list";
    GenesysDevIcons["EditorParagraphStroke"] = "editor-paragraph-stroke";
    GenesysDevIcons["EditorParagraph"] = "editor-paragraph";
    GenesysDevIcons["EditorStrikethroughStroke"] = "editor-strikethrough-stroke";
    GenesysDevIcons["EditorStrikethrough"] = "editor-strikethrough";
    GenesysDevIcons["EditorTableAddColLeft"] = "editor-table-add-col-left";
    GenesysDevIcons["EditorTableAddColRight"] = "editor-table-add-col-right";
    GenesysDevIcons["EditorTableAddRowAbove"] = "editor-table-add-row-above";
    GenesysDevIcons["EditorTableAddRowBelow"] = "editor-table-add-row-below";
    GenesysDevIcons["EditorTableStroke"] = "editor-table-stroke";
    GenesysDevIcons["EditorTable"] = "editor-table";
    GenesysDevIcons["EditorTabsStroke"] = "editor-tabs-stroke";
    GenesysDevIcons["EditorTabs"] = "editor-tabs";
    GenesysDevIcons["EditorTrashStroke"] = "editor-trash-stroke";
    GenesysDevIcons["EditorTrash"] = "editor-trash";
    GenesysDevIcons["IaAnalyticsDataManagement"] = "ia-analytics-data-management";
    GenesysDevIcons["IaAuthorization"] = "ia-authorization";
    GenesysDevIcons["IaBilling"] = "ia-billing";
    GenesysDevIcons["IaDigital"] = "ia-digital";
    GenesysDevIcons["IaGdprPrivacy"] = "ia-gdpr-privacy";
    GenesysDevIcons["IaNotificationsAlerts"] = "ia-notifications-alerts";
    GenesysDevIcons["IaOrganization"] = "ia-organization";
    GenesysDevIcons["IaPlatform"] = "ia-platform";
    GenesysDevIcons["IaRouting"] = "ia-routing";
    GenesysDevIcons["IaTelephony"] = "ia-telephony";
    GenesysDevIcons["IaUserAgentManagement"] = "ia-user-agent-management";
})(GenesysDevIcons = exports.GenesysDevIcons || (exports.GenesysDevIcons = {}));
exports.GENESYS_DEV_ICONS_CODEPOINTS = (_a = {},
    _a[GenesysDevIcons.AppAnnouncementEdit] = "61697",
    _a[GenesysDevIcons.AppAnnouncement] = "61698",
    _a[GenesysDevIcons.AppBug] = "61699",
    _a[GenesysDevIcons.AppBusiness] = "61700",
    _a[GenesysDevIcons.AppCalendar] = "61701",
    _a[GenesysDevIcons.AppChangeSet] = "61702",
    _a[GenesysDevIcons.AppCheckSolid] = "61703",
    _a[GenesysDevIcons.AppCheckStroke] = "61704",
    _a[GenesysDevIcons.AppCheck] = "61705",
    _a[GenesysDevIcons.AppChevronDown] = "61706",
    _a[GenesysDevIcons.AppChevronLeft] = "61707",
    _a[GenesysDevIcons.AppChevronRight] = "61708",
    _a[GenesysDevIcons.AppChevronUp] = "61709",
    _a[GenesysDevIcons.AppCopy] = "61710",
    _a[GenesysDevIcons.AppCriticalSolid] = "61711",
    _a[GenesysDevIcons.AppDataSource] = "61712",
    _a[GenesysDevIcons.AppDiff] = "61713",
    _a[GenesysDevIcons.AppDocumentEdit] = "61714",
    _a[GenesysDevIcons.AppDocumentEye] = "61715",
    _a[GenesysDevIcons.AppDocumentMarkdown] = "61716",
    _a[GenesysDevIcons.AppEllipsisVertical] = "61717",
    _a[GenesysDevIcons.AppEllipsis] = "61718",
    _a[GenesysDevIcons.AppEmail] = "61719",
    _a[GenesysDevIcons.AppExpand] = "61720",
    _a[GenesysDevIcons.AppExternalLink] = "61721",
    _a[GenesysDevIcons.AppEye] = "61722",
    _a[GenesysDevIcons.AppFilter] = "61723",
    _a[GenesysDevIcons.AppGripNe] = "61724",
    _a[GenesysDevIcons.AppGripNw] = "61725",
    _a[GenesysDevIcons.AppGripSe] = "61726",
    _a[GenesysDevIcons.AppGripSw] = "61727",
    _a[GenesysDevIcons.AppHandshake] = "61728",
    _a[GenesysDevIcons.AppInfoSolid] = "61729",
    _a[GenesysDevIcons.AppKey] = "61730",
    _a[GenesysDevIcons.AppLink] = "61731",
    _a[GenesysDevIcons.AppListView] = "61732",
    _a[GenesysDevIcons.AppLocation] = "61733",
    _a[GenesysDevIcons.AppMinusSolid] = "61734",
    _a[GenesysDevIcons.AppMinusStroke] = "61735",
    _a[GenesysDevIcons.AppMinus] = "61736",
    _a[GenesysDevIcons.AppMoon] = "61737",
    _a[GenesysDevIcons.AppNotificationsSolid] = "61738",
    _a[GenesysDevIcons.AppNotifications] = "61739",
    _a[GenesysDevIcons.AppPinSolid] = "61740",
    _a[GenesysDevIcons.AppPinStroke] = "61741",
    _a[GenesysDevIcons.AppPlusSolid] = "61742",
    _a[GenesysDevIcons.AppPlusStroke] = "61743",
    _a[GenesysDevIcons.AppPlus] = "61744",
    _a[GenesysDevIcons.AppQuestionSolid] = "61745",
    _a[GenesysDevIcons.AppRefresh] = "61746",
    _a[GenesysDevIcons.AppSearch] = "61747",
    _a[GenesysDevIcons.AppShieldCheck] = "61748",
    _a[GenesysDevIcons.AppSortDown] = "61749",
    _a[GenesysDevIcons.AppSortUp] = "61750",
    _a[GenesysDevIcons.AppSort] = "61751",
    _a[GenesysDevIcons.AppStarSolidThin] = "61752",
    _a[GenesysDevIcons.AppStarSolid] = "61753",
    _a[GenesysDevIcons.AppStarStrokeThick] = "61754",
    _a[GenesysDevIcons.AppStarStroke] = "61755",
    _a[GenesysDevIcons.AppSuccessSolid] = "61756",
    _a[GenesysDevIcons.AppSun] = "61757",
    _a[GenesysDevIcons.AppThumbsDown] = "61758",
    _a[GenesysDevIcons.AppThumbsUp] = "61759",
    _a[GenesysDevIcons.AppTimesSolid] = "61760",
    _a[GenesysDevIcons.AppTimesStroke] = "61761",
    _a[GenesysDevIcons.AppTimes] = "61762",
    _a[GenesysDevIcons.AppTreeView] = "61763",
    _a[GenesysDevIcons.AppUserSolid] = "61764",
    _a[GenesysDevIcons.AppUser] = "61765",
    _a[GenesysDevIcons.AppWarnSolid] = "61766",
    _a[GenesysDevIcons.AppYeti] = "61767",
    _a[GenesysDevIcons.AppZoomZoomDown] = "61768",
    _a[GenesysDevIcons.AppZoomZoomLeft] = "61769",
    _a[GenesysDevIcons.AppZoomZoomRight] = "61770",
    _a[GenesysDevIcons.AppZoomZoomUp] = "61771",
    _a[GenesysDevIcons.BrandGithubLarge] = "61772",
    _a[GenesysDevIcons.BrandGithub] = "61773",
    _a[GenesysDevIcons.BrandMarkdown] = "61774",
    _a[GenesysDevIcons.BrandNpm] = "61775",
    _a[GenesysDevIcons.DestAccounts] = "61776",
    _a[GenesysDevIcons.DestApiExplorer] = "61777",
    _a[GenesysDevIcons.DestApi] = "61778",
    _a[GenesysDevIcons.DestAppFoundry] = "61779",
    _a[GenesysDevIcons.DestBlog] = "61780",
    _a[GenesysDevIcons.DestBlueprint] = "61781",
    _a[GenesysDevIcons.DestCog] = "61782",
    _a[GenesysDevIcons.DestForum] = "61783",
    _a[GenesysDevIcons.DestGetStarted] = "61784",
    _a[GenesysDevIcons.DestGuide] = "61785",
    _a[GenesysDevIcons.DestNotifications] = "61786",
    _a[GenesysDevIcons.DestPages] = "61787",
    _a[GenesysDevIcons.DestResourceCenter] = "61788",
    _a[GenesysDevIcons.DestSdkDoc] = "61789",
    _a[GenesysDevIcons.DestTechRef] = "61790",
    _a[GenesysDevIcons.DestTool] = "61791",
    _a[GenesysDevIcons.DestTutorial] = "61792",
    _a[GenesysDevIcons.DestVideo] = "61793",
    _a[GenesysDevIcons.DestWrench] = "61794",
    _a[GenesysDevIcons.EditorAccordionStroke] = "61795",
    _a[GenesysDevIcons.EditorAccordion] = "61796",
    _a[GenesysDevIcons.EditorAlignCenterStroke] = "61797",
    _a[GenesysDevIcons.EditorAlignCenter] = "61798",
    _a[GenesysDevIcons.EditorAlignLeftStroke] = "61799",
    _a[GenesysDevIcons.EditorAlignLeft] = "61800",
    _a[GenesysDevIcons.EditorAlignRightStroke] = "61801",
    _a[GenesysDevIcons.EditorAlignRight] = "61802",
    _a[GenesysDevIcons.EditorApi] = "61803",
    _a[GenesysDevIcons.EditorBlockquoteStroke] = "61804",
    _a[GenesysDevIcons.EditorBlockquote] = "61805",
    _a[GenesysDevIcons.EditorBoldStroke] = "61806",
    _a[GenesysDevIcons.EditorBold] = "61807",
    _a[GenesysDevIcons.EditorCalloutStroke] = "61808",
    _a[GenesysDevIcons.EditorCallout] = "61809",
    _a[GenesysDevIcons.EditorCodeStroke] = "61810",
    _a[GenesysDevIcons.EditorCode] = "61811",
    _a[GenesysDevIcons.EditorEraserStroke] = "61812",
    _a[GenesysDevIcons.EditorEraser] = "61813",
    _a[GenesysDevIcons.EditorHeadingStroke] = "61814",
    _a[GenesysDevIcons.EditorHeading] = "61815",
    _a[GenesysDevIcons.EditorHorizontalRuleStroke] = "61816",
    _a[GenesysDevIcons.EditorHorizontalRule] = "61817",
    _a[GenesysDevIcons.EditorImageStroke] = "61818",
    _a[GenesysDevIcons.EditorImage] = "61819",
    _a[GenesysDevIcons.EditorItalicStroke] = "61820",
    _a[GenesysDevIcons.EditorItalic] = "61821",
    _a[GenesysDevIcons.EditorLinkStroke] = "61822",
    _a[GenesysDevIcons.EditorLink] = "61823",
    _a[GenesysDevIcons.EditorListStroke] = "61824",
    _a[GenesysDevIcons.EditorList] = "61825",
    _a[GenesysDevIcons.EditorParagraphStroke] = "61826",
    _a[GenesysDevIcons.EditorParagraph] = "61827",
    _a[GenesysDevIcons.EditorStrikethroughStroke] = "61828",
    _a[GenesysDevIcons.EditorStrikethrough] = "61829",
    _a[GenesysDevIcons.EditorTableAddColLeft] = "61830",
    _a[GenesysDevIcons.EditorTableAddColRight] = "61831",
    _a[GenesysDevIcons.EditorTableAddRowAbove] = "61832",
    _a[GenesysDevIcons.EditorTableAddRowBelow] = "61833",
    _a[GenesysDevIcons.EditorTableStroke] = "61834",
    _a[GenesysDevIcons.EditorTable] = "61835",
    _a[GenesysDevIcons.EditorTabsStroke] = "61836",
    _a[GenesysDevIcons.EditorTabs] = "61837",
    _a[GenesysDevIcons.EditorTrashStroke] = "61838",
    _a[GenesysDevIcons.EditorTrash] = "61839",
    _a[GenesysDevIcons.IaAnalyticsDataManagement] = "61840",
    _a[GenesysDevIcons.IaAuthorization] = "61841",
    _a[GenesysDevIcons.IaBilling] = "61842",
    _a[GenesysDevIcons.IaDigital] = "61843",
    _a[GenesysDevIcons.IaGdprPrivacy] = "61844",
    _a[GenesysDevIcons.IaNotificationsAlerts] = "61845",
    _a[GenesysDevIcons.IaOrganization] = "61846",
    _a[GenesysDevIcons.IaPlatform] = "61847",
    _a[GenesysDevIcons.IaRouting] = "61848",
    _a[GenesysDevIcons.IaTelephony] = "61849",
    _a[GenesysDevIcons.IaUserAgentManagement] = "61850",
    _a);
